import { supabase } from "./supabase";

export const RECENT_VERIFICATION_SECONDS = 10 * 60;

let verificationHandler = null;
let pendingVerification = null;

const decodePayload = (token) => {
  try {
    const value = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(value.padEnd(Math.ceil(value.length / 4) * 4, "=")));
  } catch {
    return {};
  }
};

export const hasRecentAuthenticationPayload = (payload, now = Date.now() / 1000) =>
  (payload.amr || []).some(({ method, timestamp }) =>
    ["otp", "password"].includes(method) && now - Number(timestamp) <= RECENT_VERIFICATION_SECONDS
  );

export const hasRecentVerification = async () => {
  const { data } = await supabase.auth.getSession();
  const payload = decodePayload(data.session?.access_token || "");
  return hasRecentAuthenticationPayload(payload);
};

export const setRecentVerificationHandler = (handler) => {
  verificationHandler = handler;
};

export const requestRecentVerification = async (action = "continue") => {
  if (await hasRecentVerification()) return true;
  if (!verificationHandler) return false;
  if (!pendingVerification) {
    pendingVerification = Promise.resolve(verificationHandler(action)).finally(() => {
      pendingVerification = null;
    });
  }
  return pendingVerification;
};
